import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify'
import { th, en } from 'vuetify/locale'
const variables = {
  'border-color': '#CDD6E1',
  'border-opacity': 0.12,
  'high-emphasis-opacity': 0.87,
  'medium-emphasis-opacity': 0.60,
  'disabled-opacity': 0.38,
  'idle-opacity': 0.04,
  'hover-opacity': 0.04,
  'focus-opacity': 0.12,
  'selected-opacity': 0.08,
  'activated-opacity': 0.12,
  'pressed-opacity': 0.12,
  'dragged-opacity': 0.08,
  'theme-kbd': '#212529',
  'theme-on-kbd': '#FFFFFF',
  'theme-code': '#F5F5F5',
  'theme-on-code': '#000000',
  'box-shadow': '0px 12px 44px 0px #0000001F'
}
const defaultTheme = {
  dark: false,
  colors: {
    background: '#E4EFE5',//Change it!
    footer: '#4CAF50',//Change it!
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#424242',//Change it!
    'on-surface-variant': '#EEEEEE',
    primary: '#4CAF50',
    'primary-darken-1': '#777777',
    secondary: '#69BA87',//Change it!
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#2E7D32',//Change it!
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const BrickRed = {
  dark: false,
  colors: {
    background: '#F1DDD6',
    footer: '#AA302B',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#AA302B',
    'on-surface-variant': '#EEEEEE',
    primary: '#AA302B',
    'primary-darken-1': '#777777',
    secondary: '#AA302B',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#AA302B',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const Violet = {
  dark: false,
  colors: {
    background: '#E6E8F3',
    footer: '#80699F',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#80699F',
    'on-surface-variant': '#EEEEEE',
    primary: '#80699F',
    'primary-darken-1': '#777777',
    secondary: '#80699F',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#80699F',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const SkyBlue = {
  dark: false,
  colors: {
    background: '#E6F3FB',
    footer: '#75A8C7',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#75A8C7',
    'on-surface-variant': '#EEEEEE',
    primary: '#75A8C7',
    'primary-darken-1': '#777777',
    secondary: '#75A8C7',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#75A8C7',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const GardenParty = {
  dark: false,
  colors: {
    background: '#EFF7F6',
    footer: '#E4ACB7',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#7DB4C9',
    'on-surface-variant': '#EEEEEE',
    primary: '#7DB4C9',
    'primary-darken-1': '#777777',
    secondary: '#7DB4C9',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#7DB4C9',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const Summer = {
  dark: false,
  colors: {
    background: '#F3E6DB',
    footer: '#EEA441',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#EEA441',
    'on-surface-variant': '#EEEEEE',
    primary: '#EEA441',
    'primary-darken-1': '#777777',
    secondary: '#EEA441',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#EEA441',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const OceanSunset = {
  dark: false,
  colors: {
    background: '#F6EBE8',
    footer: '#4D83A7',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#ECA289',
    'on-surface-variant': '#EEEEEE',
    primary: '#ECA289',
    'primary-darken-1': '#777777',
    secondary: '#ECA289',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#ECA289',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const PastelGarden = {
  dark: false,
  colors: {
    background: '#F6E8E8',
    footer: '#8DA79A',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#E79796',
    'on-surface-variant': '#EEEEEE',
    primary: '#E79796',
    'primary-darken-1': '#777777',
    secondary: '#E79796',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#E79796',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const GoldenTeal = {
  dark: false,
  colors: {
    background: '#F7F4EF',
    footer: '#D8A055',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#466D74',
    'on-surface-variant': '#EEEEEE',
    primary: '#466D74',
    'primary-darken-1': '#777777',
    secondary: '#466D74',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#466D74',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const ForestSunset = {
  dark: false,
  colors: {
    background: '#FAF4EC',
    footer: '#DF8E73',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#4D8967',
    'on-surface-variant': '#EEEEEE',
    primary: '#4D8967',
    'primary-darken-1': '#777777',
    secondary: '#4D8967',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#4D8967',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const Sea = {
  dark: false,
  colors: {
    background: '#F0EFED',
    footer: '#126973',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#126973',
    'on-surface-variant': '#EEEEEE',
    primary: '#126973',
    'primary-darken-1': '#777777',
    secondary: '#126973',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#126973',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const Blueberries = {
  dark: false,
  colors: {
    background: '#F6F7F9',
    footer: '#90768F',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#284361',
    'on-surface-variant': '#EEEEEE',
    primary: '#284361',
    'primary-darken-1': '#777777',
    secondary: '#284361',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#284361',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}
const Chocolate = {
  dark: false,
  colors: {
    background: '#F2E8E6',
    footer: '#734939',
    header: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#A68572',
    'on-surface-variant': '#EEEEEE',
    primary: '#A68572',
    'primary-darken-1': '#777777',
    secondary: '#A68572',
    'on-secondary': '#FFFFFF',
    'secondary-darken-1': '#A68572',
    'on-secondary-darken-1': '#FFFFFF',
    error: '#D44747',
    info: '#029ce5',
    success: '#69BA87',
    warning: '#d47301',
    'warning-bg': '#F0E5D7',
    'success-bg': '#D1E7D3',
  },
  variables
}

export default createVuetify({
  theme: {
    // defaultTheme: 'dark',
    // options: { customProperties: true },
    dark: false,
    defaultTheme: 'defaultTheme',
    themes: {
      defaultTheme,
      BrickRed,
      Violet,
      SkyBlue,
      GardenParty,
      Summer,
      OceanSunset,
      PastelGarden,
      GoldenTeal,
      ForestSunset,
      Sea,
      Blueberries,
      Chocolate
    },
  },
  locale: {
    locale: 'th',
    fallback: 'th',
    messages: { th, en, lo: en },
  },
})
